//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


    import Vue from "vue"

    
    
let _i18n_vue = new Vue()
// eslint-disable-next-line no-unused-vars
const $t = _i18n_vue.$t.bind(_i18n_vue)

const FAIL = 3
const SUCCESS = 2
const LOADING = 1

export default {
  name: "VocHeaderDownload",
  data() {
    return {
      downloadShow: false
    }
  },
  props: {
    isDot: {
      type: Boolean,
      default: false
    },
    dataList: {
      type: Array,
      default: function () {
        return []
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    pageSize: {
      type: Number,
      default: 5
    },
    total: {
      type: Number,
      default: 0
    },
    count: {
      type: Number,
      default: 0
    },
    appName: {
      type: String,
      default: "hotelcem"
    }
  },
  watch: {
    downloadShow(val) {
      this.$emit("showChange", val)
    }
  },
  methods: {
    // 加载
    loadList() {
      console.log(111)
      this.$emit("addCount")
      this.$emit("fetchDownloadList")
    },
    getStatusTxt(obj) {
      let status = {}
      if (obj === LOADING || obj === 10) {
        status.txt = $t("4b3340f7872b411f")
        status.classname = "cancel"
      } else if (obj === SUCCESS) {
        status.txt = $t("245883c80f181c4a")
        status.classname = "download"
      } else {
        status.txt = $t("ceb0f1f17c8c088a")
        status.classname = "retry"
      }
      return status
    },
    // 下载操作
    downloadOprate(obj, index) {
      if (obj.status === FAIL) {
        this.$emit("fetchDataRetry", obj, index)
      } else if (obj.status === SUCCESS) {
        this.$emit("download", obj, index)
      } else {
        this.$emit("fetchDataDelete", obj)
      }
    }
  }
}
